/* ==========================================================================
   cdx-liefer-live.js — echte ShipX-Raten auf der Produktseite (15.09.2026, Leon)
   ==========================================================================
   Die Lieferoptionen-Section rechnet den Wunschort-Betrag aus der Gewichts-
   staffel in den Theme-Einstellungen nach. Das ist ein Nachbau der ShipX-
   Szenarien und laeuft auseinander, sobald jemand nur ShipX pflegt (Befund
   15.09.2026: Staffel sagt 249 EUR bei 120 kg, ShipX im AT-Markt 203 EUR).

   Dieses Script holt stattdessen die echten Raten - ohne den Warenkorb des
   Kunden anzufassen: Es legt ueber die Storefront API einen WEGWERF-CART mit
   der gewaehlten Variante an, gibt ihm eine Platzhalter-Adresse im Land des
   Markts und fragt seine Lieferoptionen ab. Shopify rechnet dafuer dieselben
   Raten wie im Checkout, ShipX eingeschlossen. Der Cookie-Warenkorb bleibt
   unberuehrt, kein Tracking zaehlt einen Add-to-cart.

   Zwei Anfragen, zusammen etwa 1,5 s: cartCreate, dann eine Abfrage mit
   @defer, weil deliveryGroups(withCarrierRates: true) nur so erlaubt ist.
   Die Antwort kommt als multipart/mixed, die JSON-Teile werden zeilenweise
   eingesammelt. Ergebnis je Markt und Variante im sessionStorage, ein
   Variantenwechsel kostet danach nichts mehr.

   Sicherungen:
   - Kein Token, kein Land, keine Testadresse fuer das Land: nichts passiert,
     die Staffel bleibt stehen.
   - Antwortet Shopify mit einem anderen Land als angefragt (der Headless-
     Kanal ist dem Markt nicht zugewiesen), wird NICHT geschrieben - sonst
     saehe der deutsche Markt oesterreichische Preise.
   - Keine Rate mit passendem Namen: die Kachel bleibt, wie Liquid sie
     gerendert hat.
   - Ein Zaehler verwirft verspaetete Antworten nach einem Variantenwechsel.

   Datenquelle im Markup: das <section data-liefer-live> in
   sections/cdx-product-delivery.liquid, dort stehen Token, Land, Variante,
   Testadressen, Ratennamen und das Geldformat als data-Attribute.
   ========================================================================== */
(function () {
  'use strict';
  /* Section und Buybox-Modal binden dasselbe Script ein - einmal reicht. Die
     Konfiguration kommt vom ersten [data-liefer-live], angewendet wird auf
     alle Kacheln mit data-liefer-rolle im Dokument (Section unten UND Modal). */
  if (window.cdxLieferLive) return;
  window.cdxLieferLive = true;
  var root = document.querySelector('[data-liefer-live]');
  if (!root) return;
  var d = root.dataset;
  var token = d.sfToken || '';
  var url = d.sfUrl || '';
  var land = (d.land || '').toUpperCase();
  if (!token || !url || land.length !== 2) return;

  /* Testadressen: eine Zeile je Land, "AT=1010 Wien" */
  var adressen = {};
  (d.testadressen || '').split(/\r?\n/).forEach(function (zeile) {
    var kv = zeile.split('=');
    if (kv.length < 2) return;
    var teile = kv.slice(1).join('=').trim().split(/\s+/);
    if (teile.length < 2) return;
    adressen[kv[0].trim().toUpperCase()] = { zip: teile[0], city: teile.slice(1).join(' ') };
  });
  var adr = adressen[land];
  if (!adr) return;

  var namen = {
    wunschort: (d.nameWunschort || 'Wunschort').toLowerCase(),
    bordsteinkante: (d.nameBordsteinkante || 'Frei Bordsteinkante').toLowerCase()
  };

  /* Geldformat aus einem von Liquid gerenderten Beispiel (1234.56) ableiten */
  var sample = d.money || '';
  function money(amount) {
    var de = amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var en = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (sample.indexOf('1.234,56') >= 0) return sample.replace('1.234,56', de);
    if (sample.indexOf('1,234.56') >= 0) return sample.replace('1,234.56', en);
    if (sample.indexOf('1234,56') >= 0) return sample.replace('1234,56', de.replace(/\./g, ''));
    if (sample.indexOf('1234.56') >= 0) return sample.replace('1234.56', en.replace(/,/g, ''));
    /* Mehrsprachigkeit (30.09.2026): unbekanntes Geldformat (z. B. CHF) -> Zahlenformat der Seitensprache */
    var loc = amount.toLocaleString(document.documentElement.lang || 'de', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return loc + ' ' + (d.currency || '');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function gql(query, variables, accept) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': accept || 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
  }
  /* multipart/mixed: jede Zeile, die mit { beginnt, ist ein JSON-Teil */
  function teile(text) {
    var out = [];
    text.split(/\r?\n/).forEach(function (l) {
      l = l.trim();
      if (l.charAt(0) !== '{') return;
      try { out.push(JSON.parse(l)); } catch (e) { /* kein JSON, Rand des Multiparts */ }
    });
    return out;
  }

  var CREATE = 'mutation($vid:ID!,$addr:CartDeliveryAddressInput!) @inContext(country: ' + land + ') {'
    + ' cartCreate(input:{ lines:[{merchandiseId:$vid, quantity:1}], buyerIdentity:{ countryCode: ' + land + ' },'
    + ' delivery:{ addresses:[{ selected:true, oneTimeUse:true, address:{ deliveryAddress:$addr } }] } }) {'
    + ' cart{ id } userErrors{ message } } }';
  var RATES = 'query($id:ID!) @inContext(country: ' + land + ') { cart(id:$id){ id ... @defer {'
    + ' deliveryGroups(first:5, withCarrierRates:true){ nodes{ deliveryOptions{ title estimatedCost{ amount currencyCode } } } } } } }';

  function laden(variantId) {
    if (!variantId) return Promise.resolve(null);
    var key = 'cdxliefer:' + land + ':' + variantId;
    try { var c = sessionStorage.getItem(key); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) { /* privat, egal */ }
    var vars = { vid: 'gid://shopify/ProductVariant/' + variantId, addr: { countryCode: land, zip: adr.zip, city: adr.city, address1: 'Platzhalter 1', firstName: 'Lieferoption', lastName: 'Vorschau' } };
    return gql(CREATE, vars).then(function (t) {
      var r = JSON.parse(t);
      var ctx = r.extensions && r.extensions.context && r.extensions.context.country;
      if (ctx && ctx.toUpperCase() !== land) throw new Error('Markt ' + land + ' nicht im Kanal (Antwort ' + ctx + ')');
      var cart = r.data && r.data.cartCreate && r.data.cartCreate.cart;
      if (!cart || !cart.id) throw new Error('kein Cart');
      return gql(RATES, { id: cart.id }, 'multipart/mixed; deferSpec=20220824, application/json');
    }).then(function (t) {
      var rates = [];
      teile(t).forEach(function (p) {
        var inc = p.incremental || [];
        inc.forEach(function (i) {
          var groups = i.data && i.data.deliveryGroups && i.data.deliveryGroups.nodes || [];
          groups.forEach(function (g) { (g.deliveryOptions || []).forEach(function (o) { rates.push({ title: o.title, amount: parseFloat(o.estimatedCost.amount), currency: o.estimatedCost.currencyCode }); }); });
        });
      });
      if (rates.length) { try { sessionStorage.setItem(key, JSON.stringify(rates)); } catch (e) { /* egal */ } }
      return rates;
    });
  }

  function anwenden(rates) {
    if (!rates || !rates.length) return;
    document.querySelectorAll('[data-liefer-rolle]').forEach(function (tile) {
      var box = tile.closest('[data-liefer-live]');
      var t = box ? box.dataset : d;
      var rolle = tile.getAttribute('data-liefer-rolle');
      var name = namen[rolle];
      if (!name) return;
      var rate = null;
      rates.forEach(function (r) { if (!rate && r.title.toLowerCase().indexOf(name) === 0) rate = r; });
      if (!rate) return;
      var span = tile.querySelector('[data-liefer-preis]');
      if (!span) return;
      var cta = span.querySelector('.liefer-cta');
      var html = rate.amount > 0 ? esc(money(rate.amount)) + '<small>' + esc(t.note || d.note || btT('cdx_liefer_live.incl_vat', 'inkl. MwSt.')) + '</small>' : esc(t.frei || d.frei || btT('cdx_liefer_live.free', 'Kostenlos'));
      span.innerHTML = html;
      if (cta) span.appendChild(cta);
      tile.setAttribute('data-liefer-quelle', 'live');
    });
    document.querySelectorAll('[data-liefer-live]').forEach(function (b) { b.setAttribute('data-liefer-quelle', 'live'); });
  }

  var lauf = 0;
  function aktualisieren(variantId) {
    var mein = ++lauf;
    laden(variantId).then(function (rates) { if (mein === lauf) anwenden(rates); }).catch(function (e) {
      if (window.console && console.debug) console.debug('[cdx-liefer-live] ' + e.message);
    });
  }

  aktualisieren(d.variant);
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) { root.dataset.variant = v.id; aktualisieren(v.id); }
  });
})();
